import styled, {ThemeProvider} from 'styled-components';
import {bgBody, linkColor, gray500} from '../themes/color';
import {useState} from 'react';
import {GlobalStyles} from '../themes/global';

const MasterContainer = styled.div`
  display: flex;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  margin: auto;
  background: ${bgBody};
  transition: all 200ms ease-in-out;
`;

let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

const ThemeIcon = styled.i`
  position: fixed;
  top: .5rem;
  right: .5rem;
  padding: .5rem;
  cursor: pointer;
  ${linkColor};

  @media print {
    display: none;
  }
`;

const Copyright = styled.small`
  position: fixed;
  bottom: .75rem;
  right: .75rem;
  padding: .25rem .5rem;
  font-style: normal;
  font-weight: 500;
  font-size: .75rem;
  line-height: 1;
  color: ${gray500};
  background: ${bgBody};
`;

const BodyWrapper = (Component) => {
  return ThemeMode;

  function ThemeMode() {
    const [lightMode, setLightMode] = useState(true);
    return (
      <ThemeProvider theme={{mode: (lightMode ? 'light' : 'dark')}}>
        <GlobalStyles/>
        <MasterContainer>
          <ThemeIcon className="material-icons"
                     onClick={() => setLightMode(!lightMode)}> {lightMode ? 'dark_mode' : 'light_mode'}
          </ThemeIcon>
          <Component/>
          <Copyright>© 2021 Jon Minimal</Copyright>
        </MasterContainer>
      </ThemeProvider>
    );
  }
};

export default BodyWrapper;
